import axios, { InternalAxiosRequestConfig } from "axios";
import { addAuthHeader } from "src/utils/auth";
import { vitecompanyserviceurl } from "src/constants/global-const";

const eventInstance = axios.create({
  baseURL: vitecompanyserviceurl + "/event/order_type_exception",
});

eventInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

export const addOrderTypeException = async (data: any) => {
  return eventInstance.post("/add", data);
};

